import { Place } from '../models/Place';
import { IPlace } from '../models/interfaces/IPlace';
import { Trail } from '../models/Trail';
import { ITrail } from '../models/interfaces/ITrail';

export const helloWorld = () => {
	return 'hello world';
};

// TODO: Can these metas be ran on creation of data rather than client side?
export const generatePlaceMetaString = (place: Place | IPlace): string => {
	let location = place.location_name;

	let trailsStr = '';
	let trails = place.fkTrails ? place.fkTrails.length : 0;
	if (trails > 0) {
		trailsStr = trails > 1 ? `${trails} Trails` : `${trails} Trail`;
	}

	let locationStr = '';
	if (location) {
		locationStr = location;
		if (trailsStr) locationStr += ' • ';
	}

	return `${locationStr}${trailsStr}`;
};

export const generateTrailMetaString = (trail: Trail | ITrail): string => {
	const difficulties = [
		'Fully accessible',
		'Easier access',
		'Easy',
		'Moderate',
		'Hard',
		'Challenging',
	];
	const points = trail.points;

	let distance = 0;
	points.forEach((point, i) => {
		if (points[i + 1]) {
			const nextPoint = points[i + 1];
			// console.log(`point: ${point.title}-${i}, distance: ${distance}`);
			const dist = getDistanceFromLatLonInKm(
				point.lat,
				point.lng,
				nextPoint.lat,
				nextPoint.lng,
			);
			distance += dist;
		}
	});
	const elevationString = trail.location.elevation
		? Math.round(trail.location.elevation) + 'm'
		: '';
	const distanceString = (Math.round(distance * 10) / 10).toString() + 'km';
	const estimatedTimeString = calculateWalkingSpeed(distance); // calc time based on distance
	const difficultyString = difficulties[Math.round(trail.difficulty / 2) - 1];

	// console.log(trail);
	// console.log(distance);
	return [
		distanceString,
		elevationString,
		estimatedTimeString,
		difficultyString,
	]
		.filter(Boolean)
		.join(' • ');
};

const calculateWalkingSpeed = (distance: number): string => {
	const km = Math.ceil(distance);
	const avgSpeed = 15;
	const totalMin = km * avgSpeed;
	return `${Math.floor(totalMin / 60)}h ${totalMin % 60}m`;
};

// As the crow flies...
function getDistanceFromLatLonInKm(lat1: any, lon1: any, lat2: any, lon2: any) {
	var R = 6371; // Radius of the earth in km
	var dLat = deg2rad(lat2 - lat1); // deg2rad below
	var dLon = deg2rad(lon2 - lon1);
	var a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(deg2rad(lat1)) *
			Math.cos(deg2rad(lat2)) *
			Math.sin(dLon / 2) *
			Math.sin(dLon / 2);
	var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	var d = R * c; // Distance in km
	return d;
}

function deg2rad(deg: any) {
	return deg * (Math.PI / 180);
}
